module.exports = __webpack_public_path__ + "static/media/magento.a6d344b1.svg";